import {
  CalendarFilled,
  CloseCircleOutlined,
  PhoneFilled,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  InputNumber,
  Radio,
  Row,
  Select,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { Phone, X } from "react-feather";
import { Link, useNavigate } from "react-router";
import GenderTag from "../components/misc/GenderTag";
import ClientSelector from "../components/Orders/ClientSelector";
import { Client } from "../entities/interfaces/client";
import ClientInfo from "../components/Orders/ClientInfo";
import StaffSelector from "../components/Orders/StaffSelector";
import { Staff } from "../entities/interfaces/staffs";
import ServiceSelector, {
  Selection,
} from "../components/Orders/ServiceSelector";
import useOrder from "../hooks/useOrder";
import OrderSummary from "../components/Orders/OrderSummary";
import { PaymentStatus } from "../entities/interfaces/order";
import ServiceSelectorV2 from "../components/Orders/ServiceSelectorV2";
import BillModal from "../components/Orders/BillModal";
import BillLayout from "../components/Orders/BillLayout";
import { useStore } from "../context/StoreContext";
import toast from "react-hot-toast";

const CreateOrderV2 = () => {
  const {
    client,
    paymentMode,
    amount,
    orderItems,
    membership,
    includeTax,
    services,
    paymentStatus,
    loading,
    order,
    updateField,
    validate,
    clear,
    initiateOrder,
    retryPayment,
    createManualOrder,
    makeManualPayment,
  } = useOrder();
  const { selectedStore } = useStore();
  const naviagte = useNavigate();
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onEscape();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const onEscape = () => {
    clear();
  };

  return (
    <Row
      // style={{ height: "calc(100vh - 600px)" }}
      gutter={40}
    >
      <Col
        span={16}
        className="col-span-8 flex flex-col "
        style={{ height: "calc(100vh - 150px)" }}
      >
        <div className="flex justify-between">
          <Breadcrumb
            items={[
              {
                title: <Link to={"/orders"}>Orders</Link>,
              },
              {
                title: "Create Order",
              },
            ]}
          />
          {/* <Button className="mr-5" onClick={clear}>
            Clear
          </Button> */}
        </div>

        <div className="mt-5  flex-1 overflow-y-auto">
          <div className="border-b py-4 px-8">
            <h1 className="text-lg font-semibold mb-3">1. Select Client</h1>
            <ClientSelector
              onChange={(value) => updateField("client", value)}
              disabled={false}
              value={client}
            />
            {client && <ClientInfo client={client} />}
          </div>

          <div className="border-b py-4 px-8">
            <h1 className="text-lg font-semibold mb-3">2. Select Services</h1>
            <ServiceSelectorV2
              onChange={(value) => updateField("services", value)}
              disabled={false}
              member={client?.membership?.isActive || false}
              onError={setError}
              value={services}
            />
          </div>
          <div className="border-b py-4 px-8">
            <h1 className="text-lg font-semibold mb-3">
              3. Membership & Vouchers
            </h1>
            <Checkbox
              value={membership}
              onChange={(value) =>
                updateField("membership", value.target.checked)
              }
            >
              Add Membership
            </Checkbox>
          </div>
          <div className="py-4 px-8">
            <h1 className="text-lg font-semibold mb-3">Billing Date</h1>
            <DatePicker
              onChange={(value) =>
                updateField("billingDate", value.toISOString())
              }
              className="w-2/6"
            />
          </div>
        </div>
      </Col>
      <Col className="col-span-5" span={8}>
        <OrderSummary
          subtotal={amount.subtotal}
          tax={amount.tax}
          total={amount.total}
          items={orderItems}
          membershipDiscount={amount.membershipDiscount}
        />
        <Checkbox
          className="mt-8"
          checked={includeTax}
          onChange={(value) => updateField("includeTax", value.target.checked)}
        >
          Include Tax
        </Checkbox>

        <Radio.Group
          block
          // disabled={freezeService}
          className="mt-4"
          options={[
            { label: "Cash", value: "CASH" },
            { label: "Card", value: "CARD" },
            { label: "UPI", value: "UPI" },
          ]}
          optionType="button"
          buttonStyle="solid"
          value={paymentMode}
          onChange={(e) => updateField("paymentMode", e.target.value)}
        />
        <Divider />

        {paymentStatus === PaymentStatus.FAILED ? (
          <Button
            size="large"
            variant="solid"
            color="red"
            className="w-full"
            onClick={retryPayment}
            disabled={loading}
          >
            Retry Payment
          </Button>
        ) : (
          // <Button
          //   size="large"
          //   variant="solid"
          //   color="green"
          //   className="w-full"
          //   loading={loading}
          //   disabled={!validate() || loading}
          //   onClick={initiateOrder}
          // >
          //   Create Order
          // </Button>
          <></>
        )}
        <Button
          size="large"
          variant="solid"
          color="green"
          className="w-full"
          loading={loading}
          disabled={!validate()}
          onClick={async () => {
            if (error) {
              toast.error(error);
              return;
            }
            const order = await createManualOrder();
            await makeManualPayment();
            order && naviagte(`/orders/${order.id}`);
          }}
        >
          Create Manual Order
        </Button>
        {/* {order && (
          <BillModal open={billPrint} onClose={() => {}}>
            <>
              {selectedStore ? (
                <BillLayout store={selectedStore} order={order} />
              ) : (
                "Select a store"
              )}
            </>
          </BillModal>
        )} */}
      </Col>
    </Row>
  );
};

export default CreateOrderV2;
